import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getUnits = async ({ commit }) => {
  commit('setUnitIsLoading', true);
  let url = `/units/selectable`;

  await connection.get(url)
    .then(res => {
      const units = res.data.data;
      commit('setUnitsSelectable', units);
      commit('setUnitIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUnitIsLoading', false);
    });
}

export const loadUnits = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setUnitIsLoading', true);
    let url = `/units`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        console.log(res);
        const units = res.data.data;
        commit('setUnits', units);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setUnitsPaginated', res.data);
        commit('setUnitIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setUnitIsLoading', false);
      });
}

export const unitById = async ({ commit }, id) => {
  commit('setUnitIsLoading', true);
  await connection.get(`/units/${id}`)
    .then(res => {
      commit('setUnitDetail', res.data.data);
      commit('setUnitIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUnitIsLoading', false);
    });
}

export const storeUnit = async ({ commit }, unit) => {
  commit('setUnitIsCreating', true);
  await connection.post(`/units/create`, unit)
    .then(res => {
      commit('saveNewUnits', res.data.data);
      commit('setUnitIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUnitIsCreating', false);
    });
}

export const updateUnit = async ({ commit }, unit ) => {
  commit('setUnitIsUpdating', true);
  await connection.put(`/units/${unit.id}/update`, unit)
    .then(res => {
      commit('saveUpdatedUnit', res.data.data);
      commit('setUnitIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUnitIsUpdating', false);
    });
}

export const deleteUnit = async ({ commit }, unit) => {
  commit('setUnitIsDeleting', true);
  await connection.delete(`/units/${unit.id}/delete`)
    .then(res => {
      commit('setDeleteUnit', res.data.data);
      commit('setUnitIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setUnitIsDeleting', false);
    });
}
